import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { trackCxFoundationsOrderListPageIssueUnrelatedButtonClick } from "@faire/web-api/events/cxFoundations/click/orderListPageIssueUnrelatedButton";
export var trackClickOnIssueUnrelatedToOrder = function trackClickOnIssueUnrelatedToOrder() {
  trackCxFoundationsOrderListPageIssueUnrelatedButtonClick(getRetailerOrBrandToken());
};